import React, { useEffect, useState } from 'react'
import {
  CodarxDropDown,
  CodarxInput,
  CodarxModal,
  CodarxTimePicker,
} from 'components'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import moment from 'moment'
import { DangerVector } from 'assets/images'
import { useSelector } from 'react-redux'

const initialValues = {
  start_time: undefined,
  end_time: undefined,
  default_capacity: undefined,
  before_delivery_time: undefined,
  day: undefined,
}

const validationSchema = Yup.object({
  start_time: Yup.mixed().required('این فیلد الزامی است'),
  end_time: Yup.mixed().required('این فیلد الزامی است'),
  default_capacity: Yup.number().required('این فیلد الزامی است'),
  before_delivery_time: Yup.number().required('این فیلد الزامی است'),
  day: Yup.string().required('این فیلد الزامی است'),
})

const weekDays = [
  { value: 'saturday', label: 'شنبه' },
  { value: 'sunday', label: 'یکشنبه' },
  { value: 'monday', label: 'دوشنبه' },
  { value: 'tuesday', label: 'سه شنبه' },
  { value: 'wednesday', label: 'چهارشنبه' },
  { value: 'thursday', label: 'پنج شنبه' },
  { value: 'friday', label: 'جمعه' },
]

function DeliveryRangeModal({ visible, onCancel, onOk, loading }) {
  const colorPalette = useSelector(({ theme }) => theme.palette)

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => onOk(values),
    validateOnChange: false,
  })

  return (
    <CodarxModal
      title="ایجاد بازه"
      visible={visible}
      okText={'تایید'}
      onOk={() => formik.submitForm()}
      onCancel={onCancel}
      confirmLoading={loading}
    >
      <div style={{ marginBottom: 16 }}>
        <CodarxDropDown
          fullWidth={true}
          placeholder="روز هفته"
          options={weekDays}
          type="contained"
          value={formik.values.day}
          onChange={(val) => {
            formik.setFieldValue('day', val)
          }}
        />
      </div>
      {formik.errors.day && (
        <div style={{ color: colorPalette.text.op_3, fontSize: 10 }}>
          <img style={{ height: 13, marginLeft: 3 }} src={DangerVector} />
          {formik.errors.day}
        </div>
      )}
      <div style={{ marginBottom: 16 }}>
        <CodarxTimePicker
          width={'100%'}
          defaultValue=""
          value={formik.values.start_time}
          onChange={(e) => {
            formik.setFieldValue('start_time', moment(e).format('HH:mm:ss'))
          }}
          placeholder={'ساعت شروع'}
        />
      </div>
      {formik.errors.start_time && (
        <div style={{ color: colorPalette.text.op_3, fontSize: 10 }}>
          <img style={{ height: 13, marginLeft: 3 }} src={DangerVector} />
          {formik.errors.start_time}
        </div>
      )}
      <div style={{ marginBottom: 16 }}>
        <CodarxTimePicker
          width={'100%'}
          defaultValue=""
          value={formik.values.end_time}
          onChange={(e) => {
            formik.setFieldValue('end_time', moment(e).format('HH:mm:ss'))
          }}
          placeholder={'ساعت پایان'}
        />
      </div>
      {formik.errors.end_time && (
        <div style={{ color: colorPalette.text.op_3, fontSize: 10 }}>
          <img style={{ height: 13, marginLeft: 3 }} src={DangerVector} />
          {formik.errors.end_time}
        </div>
      )}
      <div style={{ marginBottom: 16 }}>
        <CodarxInput
          type={'number'}
          placeholder={'تعداد پیک'}
          message={
            formik.errors.default_capacity && {
              type: 'error',
              rightComponent: formik.errors.default_capacity,
            }
          }
          onChange={(e) =>
            formik.setFieldValue('default_capacity', e.target.value)
          }
          value={formik.values.default_capacity}
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <CodarxInput
          type={'number'}
          placeholder={'تعداد ساعت قبل از غیرفعال شدن بازه'}
          message={
            formik.errors.before_delivery_time && {
              type: 'error',
              rightComponent: formik.errors.before_delivery_time,
            }
          }
          onChange={(e) =>
            formik.setFieldValue('before_delivery_time', e.target.value)
          }
          value={formik.values.before_delivery_time}
        />
      </div>
    </CodarxModal>
  )
}

export { DeliveryRangeModal }
